  /**
   * @memberof rmOBA
   * @ngdoc directive
   * @name rmFormRow
   * @param  {service} $filter Angular filter function. Selects a subset of items from array and returns it as a new array
   * @description
   *   Directive to dynamically create form input elements.
   *
   *   Will create input:text, input:textarea and select elements from data supplied.
   *   
   * @attr {object} element-data 
   *    This is the element data object direct from the OrderLines spreadsheet. It contains all of the parameters for when to display, what pattern to error on, which lookup to use etc. 
   * @attr {object} rm-form-model
   *    The Angular model to which the field values are bound. This model exists in the parent form $scope, so we are passing it down as an attribute.
   * @attr {string} selected-product-id
   *    The selected product ID. Used as filter value to determine dropdown options and general states of the field - ie should it be shown, is it mandatory etc.
   * @attr {array} drop-down-options
   *    This is the data returned from the lookup for this Order Line field
   * @example
   *   Usage:
   *        <rm-form-row element-data="orderLine" rm-form-model="order" drop-down-options="lookUps[orderLine.Lookup]" selected-product-id="selectedProduct.value.ID"></rm-form-row>
   */
rmOBA.directive('rmFormRow', ['$filter', function rmFormRow($filter) {
    return {
        restrict: 'E',
        scope: {
            elementData: '=', // options for the form element field from 
            rmFormModel: '=',
            selectedProduct: '=',
            lookUps: '='
        },
        link: function(scope, element) {
            scope.isFiltered = false;
            scope.elementData.MaxLength = parseInt(scope.elementData['Max Length']) + 1;
            scope.elementData.Tooltip = {
                "title": scope.elementData['Help Text'],
                // "container": element - this works but gives many horrible errors :-s
            }

            /**
            * @memberof rmFormRow
            * @function displayField
            * @desc should the field be shown or not?
            * @returns {Boolean} 
            */
            // check if the field should be displayed or not
            scope.displayField = function() {
                var displayField = true;

                // should the field be shown or not?
                if (scope.elementData['Display'] === 'FALSE') {
                    var displayField = false;
                }

                if (scope.elementData['Displayed Exceptions'] !== undefined) {
                    // for each object in elementData
                    // check if field should be shown
                    // then check if the selectedProduct matches any exceptions
                    if (scope.elementData['Displayed Exceptions'].indexOf(scope.selectedProduct.value.ID) !== -1) {
                        displayField = !displayField;
                    }
                }

                return displayField;
            }


            /**
            * @memberof rmFormRow
            * @function checkMandatory
            * @desc Check that the field is mandatory against spreadsheet data rules
            * @returns {Boolean} 
            */
            scope.checkMandatory = function() {
                var mandatory;

                if (scope.elementData['Mandatory'] == 'TRUE') {
                    mandatory = true;
                } else {
                    mandatory = false;
                }
                if (scope.selectedProduct) {

                if (typeof scope.selectedProduct.value.ID == 'string') {
                    if (scope.elementData['Mandatory Exceptions'].indexOf(scope.selectedProduct.value.ID) !== -1) {
                            mandatory = !mandatory;
                        }
                    }
                }
                return mandatory;
            }

            /**
            * @memberof rmFormRow
            * @function mandatoryField
            * @desc Set the field as mandatory if it has been changed
            * @param {object} input  
            * @returns {Boolean} input  
            */
            scope.mandatoryField = function(input) {
                var isMandatory = false,
                    isMandatoryRules = scope.checkMandatory();

                // Set whether field is mandatory or not according to the spreadsheet rules
                isMandatory = isMandatoryRules;

                if (input) {
                    // if the field has a value we want to validate its contents
                    if (input.$viewValue !== '') {
                        isMandatory = true;
                    } 

                    // If its empty then revert to the original rules.
                    if (input.$viewValue === '' || input.$viewValue === undefined || input.$viewValue === null) {
                        isMandatory = isMandatoryRules;
                    }
                }

                return isMandatory;
            }


            /**
            * @memberof rmFormRow
            * @function getDropDownOptions
            * @desc Perform the lookup for this field and return a filtered set of options
            * @returns {object} filtered set of drop down options
            */
            scope.getDropDownOptions = function() {
                var dropDownOptions = [];
                var fieldName = scope.elementData['Field'];
                var lookUp = scope.lookUps[scope.elementData.Lookup];

                if (scope.elementData['Field Type'] === 'select') {
                    // Filtered taxonomies have a 'Product' column
                    if (lookUp[0]['Product']) {
                        // and filter the results into an option list for this product
                        dropDownOptions = $filter('filter')(lookUp, {'Product':  scope.selectedProduct.value.ID});
                        // If just one option in the dropdown then set the field to the ID of that option.
                        if (dropDownOptions.length == 1) {
                            // console.log(fieldName, scope.rmFormModel[fieldName]);
                            scope.rmFormModel[fieldName] = dropDownOptions[0].ID;
                            scope.displayField = function() {return false};
                        }
                    // Fixed taxonomies have do not have a 'Product' column
                    } else {
                        dropDownOptions = lookUp;
                    }

                    // If no results when filtered hide the field
                    if (_.isEmpty(dropDownOptions)) {
                        scope.displayField = function() {return false};
                    }
                }
                return dropDownOptions;
            }

        },
        templateUrl: 'directives/rmFormRow/rmFormRow.html'
    }
}]);
